import { StockLocationInput } from '@/types/stock-location';
import { filterValueToQuery } from '@/api';

export default function stockLocation(axios: any) {
  async function getStockLocations(filter: any) {
    try {
      const response = await axios.get(`/api/stock_locations?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/stock-location] getStockLocations Error', e);
    }
    return null;
  }

  async function getStockLocation(id: number) {
    const response = await axios.get(`/api/stock_locations/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/stock-location] getStockLocation Error', e);
    }
    return null;
  }

  async function createStockLocation(payload: StockLocationInput) {
    const response = await axios.post('/api/stock_locations', payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/stock-location] createStockLocation Error', e);
    }
    return null;
  }

  async function updateStockLocation(id: number | string, payload: StockLocationInput) {
    const response = await axios.put(`/api/stock_locations/${id}`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/stock-location] updateStockLocation Error', e);
    }
    return null;
  }

  async function deleteStockLocation(id: number) {
    const response = await axios.delete(`/api/stock_locations/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/stock-location] deleteStockLocation Error', e);
    }
    return null;
  }

  return {
    getStockLocations,
    getStockLocation,
    createStockLocation,
    updateStockLocation,
    deleteStockLocation,
  };
}
